import { push } from "connected-react-router";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { Creators } from "../../actions";
import { IState } from "../reducer";
import { LoginComponent } from "./Login.component";
import { ILoginDispatchProps, ILoginStateProps } from "./types";

const mapStateToProps = (state: IState): ILoginStateProps => ({
  authenticationState: state.App._.authenticationState,
  location: state.router.location,
  loginRequestError: state.App._.loginRequestError,
  loginRequestState: state.App._.loginRequestState,
});

const mapDispatchToProps = (dispatch: Dispatch): ILoginDispatchProps => ({
  onAuthenticationSuccess: () => dispatch(push("/dashboard")),
  onLogin: (data: { identifier: string; password: string }) => dispatch((Creators as any).App.login(data)),
});

export const Login = connect(mapStateToProps, mapDispatchToProps)(LoginComponent);
